import { algoliaApi } from 'api/axios'
import { algoliaUrls } from './algolia.urls'

export const algoliaQuery = async payload => {
  return algoliaApi.post(algoliaUrls.algoliaIndex, payload)
}
